import React from "react"
import { Link, graphql } from "gatsby"
import Image from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import styles from "./blog-post.module.scss"

import clock from "../images/clock.svg" 
import calendar from "../images/calendar.svg" 

const BlogPostTemplate = ({ data, pageContext }) => {
  const post = data.markdownRemark
  const { previous, next } = pageContext

  return (
    <Layout>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />

      <article className={`${styles.markdown} text-justify`}>

        <header className="mb-16 lg:mb-0 relative h-24 md:h-32 lg:h-40 w-full flex items-center justify-center">
          <Image fluid={post.frontmatter.featuredImage.childImageSharp.fluid} className={`rounded-md absolute inset-0 h-24 md:h-32 lg:h-40 w-full ${styles.img}`} />
          <h2 className={`z-10 px-2 py-1 rounded-md bg-white ${styles.title}`}>{post.frontmatter.title}</h2>
          <div className="absolute lg:bottom-1 bottom-neg left-1 bg-white flex p-1 rounded-md">
            <img src={clock} className="h-6 mr-2" alt="Horloge (représente le temps de lecture estimé)"/>
            <span>~ {post.timeToRead} { (post.timeToRead === 1) ? "minute" : "minutes" }</span>
          </div>
          <div className="absolute lg:bottom-1 bottom-neg right-1 bg-white flex p-1 rounded-md">
            <img src={calendar} className="h-6 mr-2" alt="Calendrier (représente la date de publication)"/>
            <span>{post.frontmatter.date}</span>
          </div>
        </header>

        <div dangerouslySetInnerHTML={{ __html: post.html }}></div>
      </article>

      <nav className="mt-8">
        <ul className="flex flex-wrap justify-between list-none p-0">
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      timeToRead
      frontmatter {
        title
        date(formatString: "DD MMMM YYYY", locale: "fr-FR")
        description
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 1213) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`
